export const argumentsFlaws = [
  {
    slug: 'ARGUMENT_DEFINITION_ISSUE',
    meaning: 'Action arguments are missing, unsupported, incomplete, or incorrectly defined.',
    detectionModes: ['classifier', 'code'],
    severity: 'medium',
    fixCategories: ['actionArguments'],
    repairPolicy: 'verified_review',
    verificationBaseMustSucceed: false,
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      }
    },
    evidenceAlternatives: [
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        requestShape: {
          type: 'string'
        },
        providerRejectionObserved: {
          type: 'boolean',
          const: true
        },
        providerStatus: {
          type: 'integer',
          minimum: 400,
          maximum: 499
        }
      },
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        requestShape: {
          type: 'string'
        },
        providerDocumentationUrl: {
          type: 'string'
        },
        documentedMismatch: {
          type: 'string'
        }
      },
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        missingStructure: {
          type: 'string'
        },
        providerDocumentationUrl: {
          type: 'string'
        },
        expectedFields: {
          type: 'stringArray',
          minItems: 1
        }
      },
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        missingStructure: {
          type: 'string'
        },
        siblingFields: {
          type: 'stringArray',
          minItems: 1
        }
      },
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        contractViolation: {
          type: 'string'
        }
      }
    ],
    verificationRecipe: ['action runs with the argument removed/replaced; request matches the provider contract.', 'object decomposed into child arguments; enum list classified; run observed.', 'one key per semantic, canonical type, coherent required/defaults; payload assembled and run observed.'],
    legacyCodes: [],
    evidenceRelations: [],
    codeEvidenceAlternatives: [
      {
        argumentKeys: {
          type: 'stringArray',
          minItems: 1
        },
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        contractViolation: {
          type: 'string'
        }
      }
    ]
  },
  {
    slug: 'LOOKUP_ISSUE',
    meaning: 'An argument lookup is missing or cannot supply valid labels and values.',
    detectionModes: ['classifier', 'code'],
    severity: 'medium',
    fixCategories: ['lookups', 'responseSchema'],
    repairPolicy: 'verified_review',
    verificationBaseMustSucceed: false,
    requiredEvidence: {
      observationIds: {
        type: 'stringArray',
        minItems: 1
      }
    },
    evidenceAlternatives: [
      {
        argumentKey: {
          type: 'string'
        },
        lookupConfigured: {
          type: 'boolean',
          const: false
        },
        sourceActionId: {
          type: 'string'
        },
        sourceIsSameApp: {
          type: 'boolean',
          const: true
        },
        sourceIsReadMany: {
          type: 'boolean',
          const: true
        },
        sourceIsTargetAction: {
          type: 'boolean',
          const: false
        },
        sourceValueField: {
          type: 'string'
        },
        identifierMatchConfirmed: {
          type: 'boolean',
          const: true
        }
      },
      {
        argumentKey: {
          type: 'string'
        },
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        lookupFailedToPopulate: {
          type: 'boolean',
          const: true
        }
      }
    ],
    verificationRecipe: ['Match only the reported argumentKey from LOOKUP_ISSUE evidence. A sibling fixed list or non-list argument cannot prove this repair. A missing argumentKey fails closed.', 'Resolve the reported argument as a documented finite enum (`list.type=fixed` with nonempty labeled fixedOptions), a lookup to a matching same-app read source, or a non-list type when the value is free-form.', 'A valid fixed list or a non-list downgrade needs only the usual target base and candidate runs with matching scope. Do not require a lookup source run.', 'Wire `list.type=lookup` only to a semantically matching read action with label/value mapped, then observe populated options in a read-only source run.', 'Never replace existing valid fixedOptions with a lookup, and never wire an unrelated source just to satisfy proof. If the source action needs changes, create separate work or require human review.'],
    legacyCodes: ['LOOKUP_SOURCE_MISSING', 'LOOKUP_SOURCE_ACTION_NOT_FOUND', 'LOOKUP_SOURCE_PAYLOAD_NOT_MAPPABLE', 'LOOKUP_SOURCE_CONTRACT_CONFLICT'],
    evidenceRelations: [],
    codeEvidenceAlternatives: [
      {
        argumentKey: {
          type: 'string'
        },
        configPaths: {
          type: 'stringArray',
          minItems: 1
        },
        lookupFailedToPopulate: {
          type: 'boolean',
          const: true
        }
      }
    ]
  }
];
